// Action types for ntfy messages
// These correspond to the server action types in server/actions.go

export const ACTION_VIEW = "view";
export const ACTION_BROADCAST = "broadcast";
export const ACTION_HTTP = "http";
export const ACTION_COPY = "copy";
